import React from 'react'
import AddOnImpl from 'live/api/add-on'
import liveUiService from 'live/services/ui'
import { axisRendererRegistry } from 'live/services/charts/axis'
import widgetsActionMenu, { Action } from 'live/services/widget-actions-menu'
import WidgetAxisAlert from './channelAlerts/togglers/WidgetAxisAlert'
import { withSuspenseWrapper } from './common/hoc/SuspenseWrapper'
import './i18n'

const AlertManagementDrawer = React.lazy(() => import('./channelAlerts/components/AlertManagementDrawer'))
const DrawerOpenerDashboardOption = React.lazy(() => import('./channelAlerts/togglers/DrawerOpenerDashboardOption'))
const DrawerOpenerMoreOptions = React.lazy(() => import('./channelAlerts/togglers/DrawerOpenerMoreOptions'))
const Backdrop = React.lazy(() => import('./channelAlerts/components/Backdrop'))

// Register the widget axis renderer
axisRendererRegistry.register(WidgetAxisAlert as never)

// Register the drawer component
liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER,
    new AddOnImpl(withSuspenseWrapper(AlertManagementDrawer) as never, { order: 1 })
)

// Register the drawer opener on the dashboard view mode options dropdown menu
liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_MAIN_HEADER_DROPDOWN_MENU,
    new AddOnImpl(withSuspenseWrapper(DrawerOpenerDashboardOption) as never, { order: 4 })
)

const widgetAction: Action = {
    component: withSuspenseWrapper(DrawerOpenerMoreOptions) as never
}

// Add the widget action to the tools group on the widget more options menu
widgetsActionMenu.addToGroup(widgetAction, 'tools')

// Register the backdrop component
liveUiService.registerAddOn(
    liveUiService.uiSections.DASHBOARD_VIEW_UNDER_HEADER,
    new AddOnImpl(withSuspenseWrapper(Backdrop) as never, { order: 4 })
)
